import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import {
  analyticsCategories,
  AnalyticsEventsRegister,
  makeAnalyticsEvent
} from "seneca-common/utils/senecaAnalytics";

import { individualAssignmentsStateConfig } from "../state/consts";

const {
  // @ts-ignore
  deleteActionTypes: { "DELETE_TEACHER-ASSIGNMENTS_SUCCESS": deleteAction }
} = makeCrudStateActionFactories(individualAssignmentsStateConfig);

const makeAssignmentAnalyticsEvent = () =>
  makeAnalyticsEvent(analyticsCategories.ASSIGNMENT);

AnalyticsEventsRegister.addEventGenerators({
  [deleteAction]: makeAssignmentAnalyticsEvent
});
